module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint-0bb28fc4944b3c8ecb079906575ed3a5.svg";